module.exports = __webpack_public_path__ + "a56183a0edd5788b6fadd8a667f0c1fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-bg/blurred-bg-1.jpg
// module id = 374
// module chunks = 0